import { Observable, defer, from, of, switchMap } from 'rxjs';
import { custom } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';

export interface AntragStatuswechselResponse {
    benachrichtigungsStatus: number;
    hinweis: string;
}

interface AntragStatuswechselDialogResult {
    abgebrochen?: boolean;
    ungueltig?: boolean;
    begruendung?: string;
}

export class ModalService {
    private modals: any[] = [];
    private statuswechselDialogId = 0;

    constructor() {
    }

    add(modal: any) {
        this.modals.push(modal);
    }

    remove(id: string) {
        this.modals = this.modals.filter(x => x.id !== id);
    }

    open(id: string, data: any) {
        const modal: any = this.modals.find(x => x.id === id);
        if (modal) {
            modal.open(data);
        }
    }

    close(id: string) {
        const modal: any = this.modals.find(x => x.id === id);
        modal.close();
    }

    confirm(message?: string): Observable<boolean> {
        const modal: any = this.modals.find(x => x.id === 'modal-dialogJaNein');
        if (modal) {
            return modal.open(message);
        }
        else{
          throw new Error('Confirm-Modal not found!');
        }
    }

    antragStatuswechsel(aktion: 'Zur Überarbeitung zurückgeben' | 'Ablehnen'): Observable<string | null> {
        return defer(() => from(this.openAntragStatuswechselDialog(aktion))).pipe(
            switchMap((result: AntragStatuswechselDialogResult) => {
                if (result?.ungueltig) {
                    return this.antragStatuswechsel(aktion);
                }

                return of(result?.begruendung ?? null);
            })
        );
    }

    zeigeAntragStatuswechselErgebnis(response: AntragStatuswechselResponse): void {
        const wurdeVersendet = response?.benachrichtigungsStatus === 0;
        notify(
            {
                message: response?.hinweis || (wurdeVersendet
                    ? 'Der Status wurde geändert und die E-Mail wurde versendet.'
                    : 'Der Status wurde geändert. Bitte nehmen Sie manuell Kontakt mit dem Träger auf.'),
                width: 650,
            },
            wurdeVersendet ? 'success' : 'warning',
            6000
        );
    }

    private openAntragStatuswechselDialog(aktion: string): PromiseLike<AntragStatuswechselDialogResult> {
        const textAreaId = `antrag-statuswechsel-begruendung-${++this.statuswechselDialogId}`;
        const dialog = custom({
            title: aktion,
            messageHtml: `
                <div style="min-width: 460px; max-width: 620px;">
                    <label for="${textAreaId}">Begründung (Pflichtfeld)</label>
                    <textarea id="${textAreaId}" maxlength="1000" rows="7"
                        style="display:block; width:100%; margin-top:8px; resize:vertical;"
                        aria-required="true"></textarea>
                    <p style="margin-top:10px;">
                        Bitte tragen Sie keine unnötigen personenbezogenen Daten von Kindern ein.
                    </p>
                    <p>Mit „${aktion}“ bestätigen Sie den Statuswechsel und den Versand der Benachrichtigung.</p>
                </div>`,
            buttons: [
                {
                    text: 'Abbrechen',
                    onClick: () => ({ abgebrochen: true }),
                },
                {
                    text: aktion,
                    type: aktion === 'Ablehnen' ? 'danger' : 'default',
                    stylingMode: 'contained',
                    onClick: () => {
                        const textArea = document.getElementById(textAreaId) as HTMLTextAreaElement;
                        const begruendung = textArea?.value?.trim();
                        if (!begruendung) {
                            notify('Eine Begründung ist erforderlich.', 'error', 3000);
                            return { ungueltig: true };
                        }

                        return { begruendung };
                    },
                },
            ],
        });

        return dialog.show();
    }
}
